import { Set } from "immutable";
import { parseSeries } from "views/logic/aggregationbuilder/Series";
import generateId from "logic/generateId";
const mapTimeunit = (unit) => {
  switch (unit) {
    case "seconds":
      return "s";
    case "minutes":
      return "m";
    case "hours":
      return "h";
    case "days":
      return "d";
    case "weeks":
      return "w";
    case "months":
      return "M";
    default:
      throw new Error(`Invalid time unit: ${unit}`);
  }
};
const formatPivot = (pivot) => {
  const { type, fields, config } = pivot;
  const newConfig = { ...config };
  switch (type) {
    case "time":
      if (config.interval.type === "timeunit") {
        const { interval } = config;
        const { unit, value } = interval;
        newConfig.interval = {
          type: "timeunit",
          timeunit: `${value}${mapTimeunit(unit)}`
        };
      }
      break;
    default:
  }
  return {
    type,
    fields,
    ...newConfig
  };
};
const generateConfig = (id, name, { rollupForBackendQuery, rowPivots, columnPivots, series, sort }) => ({
  id,
  name,
  type: "pivot",
  config: {
    id: "vals",
    rollup: rollupForBackendQuery,
    row_groups: rowPivots.map(formatPivot),
    column_groups: columnPivots.map(formatPivot),
    series: series.map((s) => ({ id: s.effectiveName, ...parseSeries(s.function) })),
    sort
  }
});
export default ({ config }) => {
  const chartConfig = generateConfig(generateId(), "chart", config);
  const configBuilder = ConfigBuilder.create([chartConfig]);
  if (config.visualization === "numeric" && config.visualizationConfig && config.visualizationConfig.trend) {
    const trendConfig = {
      ...generateConfig(generateId(), "trend", config),
      timerange: { type: "offset", source: "search_type", id: chartConfig.id }
    };
    configBuilder.add(trendConfig);
  }
  if (config.eventAnnotation) {
    const eventAnnotationConfig = {
      id: generateId(),
      name: "events",
      type: "events"
    };
    configBuilder.add(eventAnnotationConfig);
  }
  return configBuilder.build();
};
class ConfigBuilder {
  constructor(values) {
    this.value = Set.of(...values);
  }
  add(val) {
    this.value = this.value.add(val);
    return this;
  }
  build() {
    return this.value.toArray();
  }
  static create(values = []) {
    return new ConfigBuilder(values);
  }
}
